import React from 'react';

interface WelcomeMessageComponentProps {
  userName?: string;
}

const WelcomeMessageComponent = ({ userName }: WelcomeMessageComponentProps) => {
  return (
    <div className="mb-8 pt-2 relative group">
      <h1 className="text-2xl font-semibold text-gray-900 inline-block">
        Добро пожаловать
        {userName && (
          <span className="text-primary transition-colors">
            <span className="text-gray-900">,</span>
            {' ' + userName}!
          </span>
        )}
        {!userName && '!'}
      </h1>
    </div>
  );
};
export default WelcomeMessageComponent;
